import { Icon, Tooltip } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import * as S from './style';

function ToggleMenu({
  menuId,
  style = {},
  children,
  icon,
  title,
  isActive,
  hasAccordionIcon = true,
  hasWarningIcon = false,
  onClick,
  disabled,
  tooltipProps = { tooltipConfig: { placement: 'top' } }
}) {
  const [childRef, setChildRef] = React.useState(null);

  const childHeight = useMemo(
    () => (childRef?.clientHeight ? `${childRef.clientHeight}px` : '100%'),
    [childRef]
  );

  return (
    <Tooltip size="lg" {...tooltipProps}>
      <S.ToggleMenu active={isActive} style={style}>
        <S.ToggleMenuHeader
          active={isActive}
          disabled={disabled}
          onClick={() => !disabled && onClick()}
        >
          <S.ToggleMenuTitle>
            {!!icon && icon}
            {title}
          </S.ToggleMenuTitle>
          <S.AccordionIconWrapper>
            {hasWarningIcon && <Icon name="warning" color="var(--color-warning-default)" />}
            {hasAccordionIcon && <Icon name="right-chevron" />}
          </S.AccordionIconWrapper>
        </S.ToggleMenuHeader>
        {children && (
          <S.ToggleMenuContent active={isActive} childHeight={childHeight} menuId={menuId}>
            <S.ToggleChildrenWrapper ref={setChildRef}>{children}</S.ToggleChildrenWrapper>
          </S.ToggleMenuContent>
        )}
      </S.ToggleMenu>
    </Tooltip>
  );
}

ToggleMenu.S = S;

ToggleMenu.protoTypes = {
  menuId: PropTypes.number,
  style: PropTypes.object,
  children: PropTypes.node,
  icon: PropTypes.node,
  title: PropTypes.string,
  isActive: PropTypes.bool,
  hasAccordionIcon: PropTypes.bool,
  hasWarningIcon: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  tooltipProps: PropTypes.object
};

export { ToggleMenu };
